var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"user__avatar",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.getInitials))]),_c('div',{staticClass:"user__info"},[_c('div',{staticClass:"user__name",attrs:{"title":_vm.getFullName}},[_vm._v(_vm._s(_vm.getFullName))]),_c('div',{staticClass:"user__role"},[_vm._v(_vm._s(_vm.getRole))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }